import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import layout from "@/layout";

Vue.use(Router);
export const constantRoutes = [
  {
    path: "/",
    component: layout,
    redirect: "/wind/wind_home",
    children: [
      {
        path: "/globe",
        name: "globe",
        component: () => import("@/views/globe/index"),
        meta: {
          title: "地球",
        },
      },
      {
        path: "/map",
        name: "map",
        component: () => import("@/views/map/index"),
        meta: {
          title: "地图",
        },
      },
      {
        path: "/windMessage",
        name: "windMessage",
        component: () => import("@/views/windMessage/index"),
        meta: {
          title: "风机详情",
        },
      },
      {
        path: "/fjmxcs",
        name: "fjmxcs",
        component: () => import("@/views/fjmxcs/fjmscs"),
        meta: {
          title: "风机详情",
        },
      },
      {
        path: "/wind",
        component: () => import("@/views/wind/index"),
        redirect: "/wind/wind_home",
        children: [
          {
            path: "wind_home",
            name: "wind_home",
            component: () => import("@/views/wind/wind_home/index"),
            meta: {
              title: "综合管理",
            },
          },
          {
            path: "wind_headroom",
            name: "wind_headroom",
            component: () => import("@/views/wind/wind_headroom/index"),
            meta: {
              title: "净空测距",
            },
          },
          {
            path: "wind_move",
            name: "wind_move",
            component: () => import("@/views/wind/wind_move/index"),
            meta: {
              title: "位移检测",
            },
          },
          {
            path: "wind_safety",
            name: "wind_safety",
            component: () => import("@/views/wind/wind_safety/index"),
            meta: {
              title: "智能安防",
            },
          },
          {
            path: "wind_fireFighting",
            name: "wind_fireFighting",
            component: () => import("@/views/wind/wind_fireFighting/index"),
            meta: {
              title: "自动消防",
            },
          },
          {
            path: "wind_ipphone",
            name: "wind_ipphone",
            component: () => import("@/views/wind/wind_ipphone/index"),
            meta: {
              title: "IP电话",
            },
          },
          {
            path: "wind_bolt",
            name: "wind_bolt",
            component: () => import("@/views/wind/wind_bolt/index"),
            meta: {
              title: "螺栓检测",
            },
          },
          {
            path: "wind_overview",
            name: "wind_overview",
            component: () => import("@/views/wind/wind_overview/index"),
            meta: {
              title: "数据总览",
            },
          },
          {
            path: "wind_stipulate",
            name: "wind_stipulate",
            component: () => import("@/views/wind/wind_stipulate/index"),
            meta: {
              title: "安全规定",
            },
          },
          {
            path: "wind_vane",
            name: "wind_vane",
            component: () => import("@/views/wind/wind_vane/index"),
            meta: {
              title: "叶片检测",
            },
          },
          {
            path: "wind_audio",
            name: "wind_audio",
            component: () => import("@/views/wind/wind_audio/index"),
            meta: {
              title: "声音检测",
            },
          },
          {
            path: "work_safety",
            name: "work_safety",
            component: () => import("@/views/wind/work_safety/index"),
            meta: {
              title: "生产安全",
            },
          },
          {
            path: "wind_patrol",
            name: "wind_patrol",
            component: () => import("@/views/wind/wind_patrol/index"),
            meta: {
              title: "巡检",
            },
          }
        ],
      },
    ],
  },
  {
    path: "/ces",
    name: "ces",
    component: () => import("@/views/ces/index"),
    meta: {
      title: "测试",
    },
  },
  // {
  //   path: "/headroomList",
  //   name: "headroomList",
  //   component: () => import("@/views/list/headroom_list/index"),
  //   meta: {
  //     title: "净空列表",
  //   },
  // },
  {
    path: "/headroomList2",
    name: "headroomList2",
    component: () => import("@/views/list/headroom_list/index2"),
    meta: {
      title: "净空列表",
    },
  },
  {
    path: "/headroomList3",
    name: "headroomList3",
    component: () => import("@/views/list/headroom_list/index3"),
    meta: {
      title: "缺陷列表",
    },
  },
  {
    path: "/headroomList4",
    name: "headroomList34",
    component: () => import("@/views/list/headroom_list/index4"),
    meta: {
      title: "松动列表",
    },
  },
  {
    path: "/audioDetectedList",
    name: "audioDetectedList",
    component: () => import("@/views/list/headroom_list/index5"),
    meta: {
      title: "叶片检测列表"
    }
  },
  {
    path: "/safetyAlarmList",
    name: "safetyAlarmList",
    component: () => import("@/views/list/headroom_list/index6"),
    meta: {
      title: "报警列表"
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
    meta: {
      title: "登录",
    },
  },
];


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
});

const router = createRouter();

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'default title';
  }
  let hasToken = store.getters.token;
  if (!hasToken && to.path !== '/login') {
    next(`/login`);
  } else {
    next();
  }
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
